import {MathUtils, Vector2} from 'three'

import type {MonaCanvasOpeningAnimation} from '../MonaCanvas'
import {OpeningAnimation} from '../MonaCanvas/opening-animation'
import type {MonaFooterLayout} from './use-mona-footer-layout'

class MonaFooterOpeningAnimation extends OpeningAnimation {
  readonly pointerPosition: Vector2 = new Vector2()
  readonly facingRotationScale = 0.65
  readonly facingPitchOffset = 0.15
  readonly initialFacingDirection = 'right'
  readonly resetPoseOnComplete = true
  constructor(layout: MonaFooterLayout) {
    super()

    const getWaveProgress = (t: number, amplitude: number) => {
      return Math.sin(t * Math.PI * 2.0) * amplitude + t
    }

    if (layout === 'desktop') {
      const start = new Vector2(-0.8, -1.7)
      const end = new Vector2(0.6, 2.0)
      this.pointerPosition.copy(start)
      const progress = {horizontal: 0, waveY: 0}

      this.timeline.to(progress, {
        horizontal: 1,
        duration: 2,
        ease: 'none',
        onUpdate: () => {
          this.pointerPosition.x = MathUtils.lerp(start.x, end.x, progress.horizontal)
          this.pointerPosition.y = MathUtils.lerp(start.y, end.y, getWaveProgress(progress.horizontal, 0.5))
        },
      })
    } else if (layout === 'tablet') {
      const start = new Vector2(-1.0, -1.2)
      const end = new Vector2(1.0, 1.5)
      this.pointerPosition.copy(start)
      const progress = {horizontal: 0, waveY: 0}

      this.timeline.to(progress, {
        horizontal: 1,
        duration: 2.5,
        ease: 'none',
        onUpdate: () => {
          this.pointerPosition.x = MathUtils.lerp(start.x, end.x, progress.horizontal)
          this.pointerPosition.y = MathUtils.lerp(start.y, end.y, getWaveProgress(progress.horizontal, 0.45))
        },
      })
    } else if (layout === 'mobile') {
      const start = new Vector2(-1.5, -1.5)
      const end = new Vector2(1.5, 1.5)

      this.pointerPosition.copy(start)
      const progress = {horizontal: 0, waveY: 0}

      this.timeline.to(progress, {
        horizontal: 1,
        duration: 2,
        ease: 'none',
        onUpdate: () => {
          this.pointerPosition.x = MathUtils.lerp(start.x, end.x, progress.horizontal)
          this.pointerPosition.y = MathUtils.lerp(start.y, end.y, getWaveProgress(progress.horizontal, 0.45))
        },
      })
    }
  }
}

export function createMonaFooterOpeningAnimation(layout: MonaFooterLayout = 'desktop'): MonaCanvasOpeningAnimation {
  return new MonaFooterOpeningAnimation(layout)
}
